import { render, staticRenderFns } from "./SeniorSearch.vue?vue&type=template&id=0a14cb5a&scoped=true&"
import script from "./SeniorSearch.vue?vue&type=script&lang=js&"
export * from "./SeniorSearch.vue?vue&type=script&lang=js&"
import style0 from "./SeniorSearch.vue?vue&type=style&index=0&id=0a14cb5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14cb5a",
  null
  
)

export default component.exports